import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export const useDeleteAllSalesOrdersMutation = () => ({
  post: useMutation({
    mutationFn: () => axios.post('/api/v4/master/delete_all/salse_orders')
  }),
});
